import { render, staticRenderFns } from "./BalanceChart.vue?vue&type=template&id=9bd4643a&scoped=true&"
import script from "./BalanceChart.vue?vue&type=script&lang=js&"
export * from "./BalanceChart.vue?vue&type=script&lang=js&"
import style0 from "./BalanceChart.vue?vue&type=style&index=0&id=9bd4643a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd4643a",
  null
  
)

export default component.exports